var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/component/x-file-upload.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { repeat } from "lit/directives/repeat.js";
import "./x-file-item";
import "./x-file-item-upload";
var XFileUpload = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.files = [];
    this.fileClassSpecs = [];
    this._uploadFiles = [];
    this._status = "default";
    this._fileInputRef = createRef();
    this._lastFileArraySize = 0;
  }
  willUpdate(_changedProperties) {
    super.willUpdate(_changedProperties);
    if (this._lastFileArraySize !== this.files.length) {
      this._lastFileArraySize = this.files.length;
      this.dispatchEvent(new CustomEvent("files-picked", { detail: { value: [...this.files] } }));
    }
  }
  render() {
    return html`
      <x-flex ${css({ gap: "8px" })}>
        <x-flex
          dropzone
          crossaxis-center
          ${css({
      padding: "24px 32px",
      gap: "24px",
      borderRadius: "8px",
      border: this._status === "dragover" ? `2px solid ${this.colors.accent}` : `2px solid transparent`,
      boxShadow: this._status === "dragover" ? `0px 0px 20px 16px rgba(17, 17, 26, 0.08)` : "none"
    })}
          @dragover=${(e) => {
      e.preventDefault();
      this._status = "dragover";
    }}
          @dragleave=${(e) => {
      e.preventDefault();
      this._status = "default";
    }}
          @drop=${(e) => {
      e.preventDefault();
      this._status = "default";
      if (!(e instanceof DragEvent) || !e.dataTransfer)
        return;
      this._handleFileInputEvent(Object.values(e.dataTransfer.files));
    }}
        >
          <x-icon ${css({ fontSize: "40px" })}> upload_file </x-icon>
          <x-text ${css({ fontSize: "20px" })}> <b> Dateien auswählen </b> </x-text>
          <x-text ${css({ fontSize: "16px" })}>
            Zieh deine Dateien hierher oder
            <x-text
              ${css({
      display: "inline-block",
      color: this.colors.accent,
      cursor: "pointer",
      fontSize: "inherit"
    })}
              @click=${() => {
      this._fileInputRef.value?.click();
    }}
            >
              wähle Dateien aus
            </x-text>
          </x-text>
          <!-- not visible, but used for file upload -->
          ${this._fileInput()}
        </x-flex>
        ${repeat(
      this.files,
      (file, index) => html`
              <x-file-item .file=${file}>
                <x-icon
                  ${css({ fontSize: "24px", position: "absolute", right: "4px", top: "4px", cursor: "pointer" })}
                  @click=${() => {
        this.files.splice(index, 1);
        this.requestUpdate();
      }}
                >
                  close
                </x-icon>
              </x-file-item>
            `
    )}
        ${this.files.length ? html`
              <x-button
                ${css({ alignSelf: "end" })}
                @click=${() => {
      this._uploadFiles.push(...this.files);
      this.files = [];
    }}
              >
                Hochladen
              </x-button>
            ` : nothing}
        ${repeat(
      this._uploadFiles,
      (file, index) => html`
              <x-file-item-upload
                .file=${file}
                .fileClassSpecs=${this.fileClassSpecs}
                @remove=${() => {
        const matchedIndex = this._uploadFiles.findIndex((f) => f === file);
        this._uploadFiles.splice(matchedIndex, 1);
        this.requestUpdate();
      }}
              >
              </x-file-item-upload>
            `
    )}
      </x-flex>
    `;
  }
  _fileInput() {
    return html`
      <input
        ${ref(this._fileInputRef)}
        type="file"
        multiple
        hidden
        @input=${() => {
      this._handleFileInputEvent();
    }}
      />
    `;
  }
  _handleFileInputEvent(files) {
    if (!this._fileInputRef.value)
      return;
    if (!files) {
      const fileList = this._fileInputRef.value?.files;
      if (!fileList || !fileList.length)
        return;
      files = Object.values(fileList);
    }
    this.files.push(...files);
    this.requestUpdate();
    this._fileInputRef.value.value = "";
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          display: "block"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XFileUpload.prototype, "files", 2);
__decorateClass([
  property({ attribute: false })
], XFileUpload.prototype, "fileClassSpecs", 2);
__decorateClass([
  state()
], XFileUpload.prototype, "_uploadFiles", 2);
__decorateClass([
  state()
], XFileUpload.prototype, "_status", 2);
__decorateClass([
  state()
], XFileUpload.prototype, "_fileInputRef", 2);
XFileUpload = __decorateClass([
  customElement("x-file-upload")
], XFileUpload);
export {
  XFileUpload
};
